import * as React from "react";
const SvgText = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 3H20V6.5H18V5H13V19H15V21H9V19H11V5H6V7H4V3Z", fill: "currentColor" }));
export default SvgText;
